//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import vRating from '~/components/v/rating.vue'
import formattedDate from '~/filters/formattedDate'
import pageMeta, { mxGetMeta } from '~/mixins/pageMeta'
import { asyncDataCatch, asyncDataStart } from '~/utils/asyncData'
import { inRange } from '~/plugins/v-js'
import settings from '~/mixins/settings'
import ReviewLocation from '~/components/section/reviewLocation'
import oldDate from '~/middleware/oldDate'

export default {
  name: 'Reviews',
  components: {
    ReviewLocation,
    vRating
  },
  middleware: [oldDate],
  filters: { formattedDate },
  mixins: [pageMeta, settings],
  async asyncData (ctx) {
    await asyncDataStart(ctx)

    try {
      await mxGetMeta(ctx, {
        meta: {
          method: 'static'
        }
      })
      let reviews = []
      const page = parseInt(ctx.route.params.page) || 1
      const lang = ctx.store.getters['lang/locale']
      const resp = await ctx.$axios.get(`/api/v2/reviews/all?page=${page}&language=${lang}`)
      const pagination = {}
      if (resp?.data?.meta) {
        const meta = resp.data.meta
        pagination.currentPage = meta.current_page
        pagination.firstNumber = meta.from
        pagination.firstNumber = meta.last_page
        pagination.path = meta.path
        pagination.perPage = meta.per_page
        pagination.total = meta.total
      }
      reviews = resp?.data?.data
      return { pagination, reviews, lang }
    } catch (e) {
      return asyncDataCatch(ctx, e)
    }
  },
  data () {
    return {
      ltype: 'region',
      pagination: {
        currentPage: 0,
        firstNumber: 0,
        lastNumber: 0,
        perPage: 0,
        path: '',
        total: 0
      },
      reviews: []
    }
  },
  mounted () {
    this.$nuxt.$on('setPage', async (event) => {
      let page = parseInt(event, 10)
      if (page <= 1) {
        page = null
      }
      const newPath = this.$router.resolve({ name: this.$route.name, query: { ...this.$route.query }, params: { page } }).href
      this.$route.params.page = page
      window.history.replaceState({}, document.title, newPath)
      await this.getReviewByPage(page)
    })
  },
  destroyed () {
    this.$nuxt.$off('setPage')
  },
  computed: {
    getBaseLink () {
      let path = ''
      const parts = this.$route.path.split('/')
      if (this.$route.params.page) {
        parts.pop()
        parts.pop()
      }
      parts.forEach((p) => {
        return (p !== '' ? path += '/' + p : '')
      })
      return process.env.appUrl + path + '/'
    }
  },
  methods: {

    getJsonLdByReview (review) {
      return {
        '@context': 'https://schema.org/',
        '@type': 'Product',
        name: 'Tubber',
        review: {
          '@type': 'Review',
          reviewRating: {
            '@type': 'Rating',
            ratingValue: inRange(review.rating, 1, 5) ? review.rating : 5,
            bestRating: 5,
            worstRating: 1
          },
          name: `${review.boat_brand} ${review.boat_model} - ${review.boat_build_year}`,
          author: {
            '@type': 'Person',
            name: review.author
          },
          reviewBody: review.review_text,
          datePublished: review.publish_date
        }
      }
    },
    async getReviewByPage (page) {
      page = page ?? 1
      let reviews = []
      const resp = await this.$axios.get(`/api/v2/reviews/all?page=${page}&language=${this.lang}`)
      const pagination = {}
      if (resp?.data?.meta) {
        const meta = resp.data.meta
        pagination.currentPage = meta.current_page
        pagination.firstNumber = meta.from
        pagination.firstNumber = meta.last_page
        pagination.path = meta.path
        pagination.perPage = meta.per_page
        pagination.total = meta.total
      }
      reviews = resp?.data?.data
      this.pagination = pagination
      this.reviews = reviews
      this.$scrollTo({ y: 0 })
    }
  },
  jsonld () {
    const items = this.reviews.map(item => this.getJsonLdByReview(item))
    return {
      name: 'Tubber',
      '@context': 'http://schema.org',
      '@type': 'ItemList',
      itemListElement: items
    }
  }
}
